function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'ice-blue': 'rgb(162, 189, 216)','yellow': 'rgb(245, 236, 71)','red': 'rgb(200, 64, 51)','black': 'rgb(0, 0, 0)','white': 'rgb(255, 255, 255)','orange': 'rgb(230, 123, 55)','pink': 'rgb(238, 146, 166)','mint-green': 'rgb(132, 181, 137)','dark-blue': 'rgb(24, 65, 144)','brown': 'rgb(75, 59, 47)','green': 'rgb(146, 190, 91)','grey': 'rgb(175, 173, 169)','charcoal': 'rgb(164, 164, 164)','amber': 'rgb(222, 160, 61)','mariner-blue': 'rgb(58, 110, 188)','mustard-yellow': 'rgb(231, 228, 88)','carmine-red': 'rgb(164, 33, 47)','catalina-blue': 'rgb(12, 46, 113)','apple-green': 'rgb(126, 192, 38)','dawn-grey': 'rgb(172, 168, 158)','turtle-green': 'rgb(130, 186, 71)','royal-blue': 'rgb(23, 75, 129)','ice-grey': 'rgb(221, 223, 215)','lilac': 'rgb(180, 165, 190)','blue': 'rgb(177, 203, 226)','pale-blue': 'rgb(198, 218, 227)','deep-blue': 'rgb(50, 76, 152)','taupe': 'rgb(177, 167, 161)','glacier-blue': 'rgb(161, 196, 223)','blue-white': 'rgb(10, 17, 91)','grey-white': 'rgb(138, 130, 122)','burgundy': 'rgb(75, 27, 35)','lavender': 'rgb(120, 85, 132)','fine-medium-blue': 'rgb(177, 203, 226)','medium-heavy-grey': 'rgb(175, 173, 169)','lime-green': 'rgb(151, 211, 78)','cloud-grey': 'rgb(144, 145, 142)','aqua-grey': 'linear-gradient(90deg, rgba(24,164,158,1) 50%, rgba(185,171,183,1) 50%)','blue-white': 'linear-gradient(90deg, rgba(1,7,94) 50%, rgba(255,255,255) 50%)','grey-white': 'linear-gradient(90deg, rgba(173,176,169) 50%, rgba(255,255,255) 50%)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
